import { render } from "./Circle.vue?vue&type=template&id=4b8bc34e&scoped=true"
import script from "./Circle.vue?vue&type=script&lang=js"
export * from "./Circle.vue?vue&type=script&lang=js"

import "./Circle.vue?vue&type=style&index=0&id=4b8bc34e&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8bc34e"]])

export default __exports__